/**
 * Letterhead URL utilities
 * Provides functions to get law firm letterhead URLs
 */

/**
 * Get the letterhead URL for a specific law firm using the letterhead file ID
 * This uses the same file download endpoint as other files
 *
 * @param letterHeadFileId - The ID of the letterhead file
 * @param asImage - Whether to get the image version for rendering (default: true)
 * @returns The URL to the letterhead image or undefined if no letterhead
 */
export function getLawFirmLetterheadUrl(
  letterHeadFileId?: number,
  asImage: boolean = true
): string | undefined {
  if (!letterHeadFileId) {
    return undefined; // No fallback - only use law firm's letterhead
  }

  // Use the standard file download endpoint with preview and image parameters
  // This will handle auth and return the presigned S3 URL
  // preview=true displays in browser, image=true gets the PNG version
  if (asImage) {
    return `/api/files/${letterHeadFileId}/download?preview=true&image=true`;
  }
  return `/api/files/${letterHeadFileId}/download`;
}
